export default __webpack_public_path__ + "static/media/facebook.712ad5c1.svg";